import { render, staticRenderFns } from "./createEdit.vue?vue&type=template&id=e334ade4"
import script from "./createEdit.vue?vue&type=script&lang=ts"
export * from "./createEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports